import React, { useEffect } from 'react';
import {
  Paper, Table, TableHead, TableRow, TableCell, TableBody, Button,
} from '@material-ui/core';
import useStyles from './styles';
import {
  getOauthClientsRequest as GetOauthClientsRequest,
  removeOauthClientsRequest as RemoveOauthClientsRequest,
  createOauthClientsRequest as CreateOauthClientsRequest,
} from '../../redux/actions/auth';
import { AuthState } from '../../redux/types/auth';
import { usePermissions } from '../../hooks/usePermissions';

type Props = {
  getOauthClientsRequest: typeof GetOauthClientsRequest,
  removeOauthClientsRequest: typeof RemoveOauthClientsRequest,
  createOauthClientsRequest: typeof CreateOauthClientsRequest,
  oauthClients: AuthState['oauthClients'],
  builderOauthClients: AuthState['builderOauthClients'],
};

const EditProfile: React.FC<Props> = ({
  getOauthClientsRequest, oauthClients, createOauthClientsRequest, removeOauthClientsRequest, builderOauthClients,
}) => {
  const classes = useStyles();

  const { canEdit } = usePermissions();

  const removeClient = (clientId: string, clientSecret: string) => () => {
    removeOauthClientsRequest(clientId, clientSecret);
  };

  const createClient = () => {
    createOauthClientsRequest();
  };

  useEffect(() => {
    getOauthClientsRequest();
  }, [getOauthClientsRequest]);

  return (
    <div>
      <Button variant="contained" color="primary" onClick={createClient} style={{ marginBottom: 25 }} disabled={!canEdit}> Add Client</Button>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Client ID</TableCell>
              <TableCell align="right">Client Secret</TableCell>
              <TableCell align="right">Created AT</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {oauthClients.map((client) => (
              <TableRow key={client.id}>
                <TableCell component="th" scope="row">
                  {client.client_id}
                </TableCell>
                <TableCell className="fs-exclude" align="right">{client.client_secret}</TableCell>
                <TableCell align="right">
                  {new Date(client.created_at).toDateString()}

                  -

                  {new Date(client.created_at).toLocaleTimeString()}
                </TableCell>
                <TableCell align="right" className={classes.cellLastWidth}>
                  <Button variant="contained" color="secondary" onClick={removeClient(client.client_id, client.client_secret)}>Remove</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      {!!builderOauthClients.length && (
        <div className={classes.container}>
          <h3 className={classes.title}>Builder API Keys</h3>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Client ID</TableCell>
                  <TableCell align="right">Client Secret</TableCell>
                  <TableCell align="right">Created AT</TableCell>
                  <TableCell align="right">User Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {builderOauthClients.map((client) => (
                  <TableRow key={client.id}>
                    <TableCell component="th" scope="row">
                      {client.client_id}
                    </TableCell>
                    <TableCell className="fs-exclude" align="right">{client.client_secret}</TableCell>
                    <TableCell align="right">
                      {new Date(client.created_at).toDateString()}
                      -
                      {new Date(client.created_at).toLocaleTimeString()}
                    </TableCell>
                    <TableCell align="right">
                      {client.user_id}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </div>
      )}
    </div>
  );
};

export default React.memo(EditProfile);
